import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

import { rem, transition } from "@ui/helpers";

const styles = css`
  position: relative;
  margin-right: ${props => props.theme.margins.base_x4};
  font-weight: ${props => props.theme.fonts.weights.semibold};
  color: ${props => props.theme.palette.grey600};
  font-size: ${props => props.theme.fonts.sizes.body};

  &::after {
    content: "";
    position: absolute;
    bottom: -${props => props.theme.margins.base};
    left: 0;
    width: 100%;
    height: ${rem(4)};
    background: ${props => props.theme.palette.grey800};
    opacity: 0;
    transform: translateY(${props => props.theme.margins.half});
    transition: ${transition(["opacity", "transform", "color"])};
  }

  &:hover {
    color: ${props => props.theme.palette.grey800};
    transition: ${transition(["color"])};
  }

  &.active {
    color: ${props => props.theme.palette.grey800};

    &::after {
      transform: none;
      opacity: 1;
    }
  }
`;

const HeaderTabLink = styled(NavLink)`
  ${styles}
`;

const HeaderTabButton = styled.button`
  ${styles}
`;

export { HeaderTabLink, HeaderTabButton };
